import {user, request, storage} from 'lib'


import find from 'lodash/find';
import assign from 'lodash/assign';
import forEach from "lodash/forEach";
import map from "lodash/map";
import uniqBy from "lodash/uniqBy";




// import {getStore} from '../store'


let carList = []
let categories = []
let CACHE_KEY = 'CARS_LIST'

let enterList = {}

const init = async () => {
  let res = await request.api.get('show/cars_list');

  carList = res.all || [];
storage.setItem(CACHE_KEY,carList)

}

const getCarList = () => {
  return carList;
}

const getCar = (carId) => {
  if(carList.length===0){
    carList = storage.getItem(CACHE_KEY)
  }
  return find(carList, {_id: carId});
}

const addEnter  = (userId) => {
  enterList[userId] = 1
}

const isEntered = (userId) => {
  // return false;
  return enterList[userId]
}

export default {
  init,
  getCar,
  getCarList,
  isEntered,
  addEnter
}

